export type ItemCardStatus = "buy-now" | "pre-order" | "auction" | "offers" | "scheduled";

export function isListingDropPending(input: {
  scheduled_publish_at?: string | null;
}): boolean {
  const scheduled = input.scheduled_publish_at;
  if (!scheduled) return false;
  const t = new Date(scheduled).getTime();
  return !Number.isNaN(t) && t > Date.now();
}

export function itemCardStatusFromListing(input: {
  scheduled_publish_at?: string | null;
  listing_format?: string | null;
  listing_type?: string | null;
  discoverTypeLabel?: string | null;
}): ItemCardStatus {
  if (isListingDropPending({ scheduled_publish_at: input.scheduled_publish_at })) {
    return "scheduled";
  }

  if (input.listing_type === "preorder" && !input.scheduled_publish_at) {
    return "pre-order";
  }

  const f = input.listing_format;
  if (f === "auction") return "auction";
  if (f === "offers_only") return "offers";
  if (f === "fixed_price_with_offers") return "offers";
  if (f === "fixed_price") return "buy-now";

  const label = input.discoverTypeLabel?.trim();
  if (label === "Pre-order") return "pre-order";
  if (label === "Auction") return "auction";
  if (label === "Offers") return "offers";
  if (label === "Buy now") return "buy-now";

  return "buy-now";
}
